import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { ArrowRightCircle } from '../Icons';
import Grid from '../Grid';
import EventsSlider from '../EventsSlider';
import * as Utils from '../../utils';

const TypesSlide = ({
  articles,
  books,
  events,
  handleNextArticle,
  id,
  index,
  isLastSlide,
  isVisible,
  podcasts,
  testimonials,
  title,
  ...rest
}) => {
  if (!isVisible) {
    return null;
  }

  const hasArticles = !!articles?.length;
  const hasTestimonials = !!testimonials?.length;
  const hasBooks = !!books?.length;
  const hasPodcasts = !!podcasts?.length;
  const hasEvents = !!events?.length;

  if (hasArticles) {
    articles = articles.map((e) => {
      return {
        ...e,
        size: 'small',
      };
    });
  }

  return (
    <div
      className={classnames('types-slide', {
        'types-slide--last': isLastSlide,
      })}
      id={id}
      data-type-slide={index}
    >
      <div className='container'>
        <div className='row'>
          <div className='col'>
            <div className='types-slide__container'>
              {!isLastSlide && (
                <button className='types-slide__cta' onClick={() => handleNextArticle(index)}>
                  <span className='types-slide__cta-title'>Next</span>
                  <ArrowRightCircle className='types-slide__cta-icon' />
                </button>
              )}
              {hasArticles && (
                <Grid className={Utils.slugify(title)} items={articles} lgCols={3} {...rest} />
              )}
              {hasTestimonials && (
                <Grid className={Utils.slugify(title)} items={testimonials} {...rest} />
              )}
              {hasBooks && <Grid className={Utils.slugify(title)} items={books} {...rest} />}
              {hasPodcasts && <Grid className={Utils.slugify(title)} items={podcasts} {...rest} />}
              {hasEvents && (
                <>
                  <Grid className={Utils.slugify(title)} items={events} {...rest} />
                  <EventsSlider events={events} />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

TypesSlide.propTypes = {
  articles: PropTypes.array,
  books: PropTypes.array,
  events: PropTypes.array,
  handleNextArticle: PropTypes.func,
  handleNextSection: PropTypes.func,
  id: PropTypes.string,
  index: PropTypes.number,
  isLastSlide: PropTypes.bool,
  isVisible: PropTypes.bool,
  podcasts: PropTypes.array,
  testimonials: PropTypes.array,
  title: PropTypes.string,
};

export default TypesSlide;
